var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { saveDocument } from './saveDocument';
export const autosave = (editor) => __awaiter(void 0, void 0, void 0, function* () {
    const revisionTracker = editor.plugins.get('RevisionTracker');
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { currentRevision } = revisionTracker;
    const oldRevisionVersion = currentRevision.toVersion;
    // Update the current revision with the newest document changes.
    yield revisionTracker.update();
    // Check if the revision was updated.
    // If not, do not make an unnecessary call.
    if (oldRevisionVersion === currentRevision.toVersion) {
        return true;
    }
    // Use the document data saved with the revision instead of the editor data.
    // Revision data may slightly differ from the editor data when
    // real-time collaboration is involved.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const documentData = yield revisionTracker.getRevisionDocumentData(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    revisionTracker.currentRevision);
    // Use revision version instead of `cloudDocumentVersion`.
    const documentVersion = currentRevision.toVersion;
    const documentId = editor.config.get('documentId');
    return saveDocument(documentId, documentData.main, documentVersion);
});
